module.exports = __webpack_public_path__ + "img/52.fa875f9c.jpeg";